import { CategoryHSCodeSuggested } from '../types';

type Listener = () => void;

const createStore = () => {
  let hsCodes = [] as CategoryHSCodeSuggested[];
  const listeners = new Set<Listener>();

  const notifyListeners = () => {
    listeners.forEach((notify) => notify());
  };

  return {
    getHSCodes: () => hsCodes,
    addHSCode: (code: string, description?: string) => {
      const existingCode = hsCodes.find((hsCode) => hsCode.code === code);
      if (existingCode) return;
      hsCodes = [...hsCodes, { code, description }];
      notifyListeners();
    },
    subscribe: (listener: Listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
          hsCodes = [];
          notifyListeners();
        }
      };
    },
  };
};

export const hsCodeStore = createStore();

export const addHSCode = (code: string, description?: string) => {
  hsCodeStore.addHSCode(code, description);
};
